import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { PageHeader } from "@/components/common/PageHeader";
import { DemoBadge } from "@/components/common/DemoBadge";
import { CreateCompany } from "@/components/business/CreateCompany";
import { BizDashboard } from "@/components/business/BizDashboard";
import { BizExpenses } from "@/components/business/BizExpenses";
import { BizCharges } from "@/components/business/BizCharges";
import { BizMap } from "@/components/business/BizMap";
import { BizContracts } from "@/components/business/BizContracts";
import { BizSettings } from "@/components/business/BizSettings";
import { BizDebts } from "@/components/business/BizDebts";
import { BizSuppliers } from "@/components/business/BizSuppliers";
import { BizEquipment } from "@/components/business/BizEquipment";
import { Skeleton } from "@/components/ui/skeleton";
import { api } from "@/lib/api";
import { useActiveCompany } from "@/lib/activeCompany";

const SECTIONS = {
  "": ["Tableau de bord", "Budgets, variations, charges récurrentes et échéances de vos contrats.", BizDashboard],
  depenses: ["Dépenses & budgets", "Opérations bancaires, part de chaque poste, comparaison à la moyenne sur 6 mois et plafonds.", BizExpenses],
  factures: ["Dettes & créances", "Factures fournisseurs à régler et montants que vos clients vous doivent, avec paiements partiels et justificatifs.", BizDebts],
  fournisseurs: ["Fournisseurs & factures", "Déposez vos factures en lot : l'IA les lit, vous validez le rapprochement avec vos opérations, et chaque fournisseur a sa fiche.", BizSuppliers],
  equipements: ["Équipements & matériel", "Inventaire du matériel, garanties, entretiens à venir et coordonnées des réparateurs.", BizEquipment],
  charges: ["Charges récurrentes", "Budget animé de vos frais récurrents : périodes, fréquences, hausses, baisses et arrêts programmés, plus les prélèvements détectés.", BizCharges],
  cartographie: ["Cartographie des fournisseurs", "Vos fournisseurs principaux par poste, avec le récap du contrat, le service client, les échéances et les économies possibles.", BizMap],
  contrats: ["Assurances & prévoyance", "Récapitulatif des garanties et réévaluation annuelle selon votre chiffre d'affaires et vos changements.", BizContracts],
  entreprise: ["Mon entreprise", "Informations, membres et rôles, changements de l'année.", BizSettings],
};

export const useCompany = (cid) => useQuery({ queryKey: ["company", cid], queryFn: () => api.get(`/business/companies/${cid}`).then((r) => r.data), enabled: !!cid });

export default function Business() {
  const { section = "" } = useParams();
  const cid = useActiveCompany()?.id;
  const { data: company } = useCompany(cid);
  if (!cid || section === "nouvelle") return <CreateCompany />;
  const [title, text, Comp] = SECTIONS[section] || SECTIONS[""];
  return (
    <div className="space-y-8" data-testid={`business-page-${section || "home"}`}>
      <PageHeader eyebrow={company ? `CASHMY Entreprise · ${company.name}` : "CASHMY Entreprise"} title={title} text={text} actions={company?.is_demo && <DemoBadge />} />
      {!company ? <Skeleton className="h-64 rounded-2xl" /> : <Comp company={company} />}
    </div>
  );
}
